module.exports = __webpack_public_path__ + "img/honor-1.ebc5262e.png";